import ChallengesTabs from '../modules/blocks/challenges';
import ModalContentSection from '../modules/blocks/modalContent';
import Contact from '../modules/blocks/contact';
import JobsPortal from '../modules/blocks/jobs-portal';
import ContentToc from '../modules/blocks/contentToc';
import JobsList from '../modules/blocks/jobs-list';

function entry() {
    new ChallengesTabs('.challenges');
    new ModalContentSection('.modal-content-section');
    new Contact('.contact');
    new JobsPortal('.jobs-portal');
    new ContentToc('.page-template-content-toc');
    new JobsList('.jobs-list');
}

window.addEventListener('DOMContentLoaded', entry);
